import { Link } from "react-router-dom";
import Seo from "../components/Seo";

function NotFound() {
  return (
    <div className="notFound">
      <Seo title="Page Not Found | QuadroCode" description="The requested page could not be found." noindex />
      <h1>404</h1>
      <p>
        This page doesn’t exist or was moved.
      </p>
      <Link to="/">
        Go back home
      </Link>
    </div>
  );
}

export default NotFound;
